import {
  Unit_instance3vdlo4e4f5ggx as Unit_instance,
  get_EmptyContinuationn1rwa6yr6j5w as get_EmptyContinuation,
  startCoroutineUninterceptedOrReturnGeneratorVersion1r5yf56916wr4 as startCoroutineUninterceptedOrReturnGeneratorVersion,
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  VOID3gxj6tk5isa35 as VOID,
  constructCallableReference23y65rf941mch as constructCallableReference,
  getKClass3t8tygqu4lcxf as getKClass,
  arrayOf1akklvh2at202 as arrayOf,
  createKType31ecntyyaay3k as createKType,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  isInterface3d6p8outrmvmk as isInterface,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  Exceptiondt2hlxn7j7vw as Exception,
  emptySetcxexqki71qfa as emptySet,
} from './kotlin-kotlin-stdlib.mjs';
import {
  startSandboxGame$defaultg40zqjy04pe6 as startSandboxGame$default,
  SandboxGameManager1l0vg1l6g6n12 as SandboxGameManager,
  PrintingGameRuntimeDiagnostics_instanceknsic9pmcauw as PrintingGameRuntimeDiagnostics_instance,
} from './beast-beast-common.mjs';
import {
  coroutineScope39ukucf23mhsm as coroutineScope,
  launch1c91vkjzdi9sd as launch,
} from './kotlinx-coroutines-core.mjs';
import { get_resourcesVfs3qrvup7jpy9uc as get_resourcesVfs } from './korlibs-io-root-korlibs-io.mjs';
import { Default_getInstanceqol46f1ssq2p as Default_getInstance } from './kotlinx-serialization-kotlinx-serialization-json.mjs';
import {
  ClientConnectionSettings1hcwxx4tfft81 as ClientConnectionSettings,
  ServerDrivenConfigurationKrpcmzyhiagna8ar as ServerDrivenConfigurationKrpc,
} from './beast-beast-krpc-base.mjs';
import {
  serializer1i4e9ym37oxmo as serializer,
  KSerializerzf77vz1967fq as KSerializer,
} from './kotlinx-serialization-kotlinx-serialization-core.mjs';
import {
  GameConfiguration2d0q42j89bphu as GameConfiguration,
  set_gameConfiguration1pq4o217f3vsu as set_gameConfiguration,
  startKorgeUi38919czmdh3gu as startKorgeUi,
} from './beast-beast-korge.mjs';
import './ktor-ktor-client-core.mjs';
//region block: imports
//endregion
//region block: pre-declaration
class ClientSandboxGameManagerImpl {
  constructor(serverDrivenConfiguration) {
    this.xmz_1 = serverDrivenConfiguration;
  }
  *g6w(gameSetupState, $completion) {
    return yield* this.xmz_1.k94(gameSetupState, $completion);
  }
  *i6w(beastAgentControl, huntersAgentControl, gameState, startParams, gameCode, sandboxEventsNumber, sandboxIdCallback, fullCheck, debugOutputSessionConfiguration, $completion) {
    yield* this.xmz_1.t95(beastAgentControl, huntersAgentControl, gameState, startParams, gameCode, sandboxEventsNumber, sandboxIdCallback, $completion);
    return Unit_instance;
  }
  *h6w(gameCode, applyingEventNumber, checkCodeBeforeEvent, event, $completion) {
    return yield* this.xmz_1.h6w(gameCode, applyingEventNumber, checkCodeBeforeEvent, event, $completion);
  }
  *k6w(beastAgentControl, huntersAgentControl, gameCode, $completion) {
    yield* this.xmz_1.u95(beastAgentControl, huntersAgentControl, gameCode, $completion);
    return Unit_instance;
  }
}
//endregion
function *main($completion) {
  installFetchCompatibility();
  yield* setupServerDrivenKorgeClient($completion);
  return Unit_instance;
}
function mainWrapper() {
  startCoroutineUninterceptedOrReturnGeneratorVersion(main, get_EmptyContinuation());
}
function *setupServerDrivenKorgeClient($completion) {
  yield* coroutineScope(setupServerDrivenKorgeClient$slambda(), $completion);
  return Unit_instance;
}
function setupServerDrivenKorgeClient$slambda$slambda($serverDrivenConfiguration) {
  return constructCallableReference(function *($this$launch, $completion) {
    yield* $serverDrivenConfiguration.s95($completion);
    return Unit_instance;
  }, 1);
}
function setupServerDrivenKorgeClient$slambda() {
  return constructCallableReference(function *($this$coroutineScope, $completion) {
    var configFile = yield* get_resourcesVfs().wi('clientConfig.json').tbh(VOID, $completion);
    var tmp;
    try {
      // Inline function 'kotlinx.serialization.json.Json.decodeFromString' call
      var this_0 = Default_getInstance();
      // Inline function 'kotlinx.serialization.serializer' call
      var this_1 = this_0.l10();
      // Inline function 'kotlinx.serialization.internal.cast' call
      var this_2 = serializer(this_1, createKType(getKClass(ClientConnectionSettings), arrayOf([]), false));
      var tmp$ret$1 = isInterface(this_2, KSerializer) ? this_2 : THROW_CCE();
      tmp = this_0.n10(tmp$ret$1, configFile);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Exception) {
        var exception = $p;
        throw IllegalStateException.q('Invalid packaged clientConfig.json', exception);
      } else {
        throw $p;
      }
    }
    var configuredSettings = tmp;
    var serverDrivenConfiguration = new ServerDrivenConfigurationKrpc(configuredSettings, PrintingGameRuntimeDiagnostics_instance);
    launch($this$coroutineScope, VOID, VOID, setupServerDrivenKorgeClient$slambda$slambda(serverDrivenConfiguration));
    set_gameConfiguration(new GameConfiguration(null, emptySet(), VOID, emptySet(), VOID, VOID, serverDrivenConfiguration, VOID, configuredSettings.p92_1, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, configuredSettings.q92_1, new ClientSandboxGameManagerImpl(serverDrivenConfiguration)));
    yield* startKorgeUi($this$coroutineScope, $completion);
    return Unit_instance;
  }, 1);
}
function installFetchCompatibility() {
  ((() => {
    const originalFetch = globalThis.fetch.bind(globalThis);
    globalThis.fetch = (input, init) => {
      if (init != null) {
        init = {...init};
        for (const key of Object.keys(init)) {
          if (init[key] == null)
            delete init[key];
        }
      }
      return originalFetch(input, init);
    };
  })());
}
//region block: post-declaration
protoOf(ClientSandboxGameManagerImpl).j6w = startSandboxGame$default;
initMetadataForClass(ClientSandboxGameManagerImpl, 'ClientSandboxGameManagerImpl', VOID, VOID, [SandboxGameManager], [1, 9, 4, 3]);
//endregion
mainWrapper();
